export const prodConfig = {
  apiKey: 'AIzaSyDasDmqMzDxq-9CMlX6VS4HyC5INc84dWM',
  authDomain: 'guidex-1536521957172.firebaseapp.com',
  databaseURL: 'https://guidex-1536521957172.firebaseio.com',
  projectId: 'guidex-1536521957172',
  storageBucket: 'guidex-1536521957172.appspot.com',
  messagingSenderId: '1065187185467'
};

export const devConfig = {
  apiKey: 'AIzaSyA3aUrx9N0X051clul5D8KT6LRCEXInPVA',
  authDomain: 'guidex-dev.firebaseapp.com',
  databaseURL: 'https://guidex-dev.firebaseio.com',
  projectId: 'guidex-dev',
  storageBucket: 'guidex-dev.appspot.com',
  messagingSenderId: '857848235265'
};



// WEBPACK FOOTER //
// ./src/firebase/api-keys.js